export default __webpack_public_path__ + "static/media/bat-potion.48330153.jpg";